import { PaperWrapped, HeaderWrapped } from '../lab-result/component/styled';
import { convertToFormData, dummyRequest } from '../lab-result/utils';
import importMassUserDispatcher from './action';
import { UseTemplateIcon } from '@/assets/svg';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import customToast from '@/new-components/CustomNotification';
import { InboxOutlined, FileTextOutlined } from '@ant-design/icons';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Upload } from 'antd';
import { isEmpty, get } from 'lodash';
import React, { useState } from 'react';

const ImportMassUser = () => {
  const [files, setFiles] = useState({});

  const handleUploadFiles = () => {
    if (isEmpty(files)) return customToast('error', 'File must not be empty');

    // Code here
    importMassUserDispatcher.uploadMassUser(
      convertToFormData(files.originFileObj, 'file')
    );
  };

  const handleDownloadTemplate = () => {
    importMassUserDispatcher.downloadUserTemplate();
  };

  const handleChangeFiles = (e) => {
    setFiles(e.file);
  };

  const handleClearFiles = () => setFiles({});

  return (
    <PaperWrapped>
      <HeaderWrapped className="no-tabs-header">
        <Typography style={{ fontSize: 18, fontWeight: 600 }}>
          Import Mass User
        </Typography>

        <div className="personal-btn">
          <ButtonEnhance
            background="#E9E9E9"
            color="black"
            backgroundHover="#ccc"
            onClick={handleClearFiles}
          >
            Clear
          </ButtonEnhance>
          <ButtonEnhance onClick={handleUploadFiles}>Upload</ButtonEnhance>
        </div>
      </HeaderWrapped>
      <Box display="flex" alignItems="center" flexDirection="column">
        <Upload.Dragger
          customRequest={dummyRequest}
          onChange={handleChangeFiles}
          showUploadList={false}
          accept={'.xlsx'}
          file={files}
        >
          <div className="upload-btn">
            <div className="group">
              <InboxOutlined />
              <div className="text">
                {isEmpty(files)
                  ? 'Click or drag file to this area to upload'
                  : `${files.name}`}
              </div>
            </div>
          </div>
        </Upload.Dragger>

        {/* <Typography style={{ fontSize: 14, color: '#666', marginBottom: 12 }}>
          If you do not have a file you can use the sample below:
        </Typography>
        <ButtonEnhance
          onClick={handleDownloadTemplate}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            padding: '8px 16px',
            backgroundColor: '#fff',
            color: '#333',
          }}
        >
          <UseTemplateIcon />
          Download Sample Template
        </ButtonEnhance> */}
      </Box>
    </PaperWrapped>
  );
};

export default ImportMassUser;
